<template>
  <div class="selectYesOrNo">
    <div
      v-if="title"
      class="selectYesOrNo_title"
    >
      {{ title }}
    </div>
    <div class="selectYesOrNo_btnArea">
      <tk-button
        class="selectYesOrNo_btn"
        @click="emitYes"
      >
        はい
      </tk-button>
      <tk-button
        class="selectYesOrNo_btn"
        @click="emitNo"
      >
        いいえ
      </tk-button>
    </div>
  </div>
</template>

<script>
import TkButton from '../TkButton/TkButton'
export default {
  name: 'TkSelectYesOrNo',
  components: {
    TkButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitYes () {
      this.$emit('isSelected', true)
    },
    emitNo () {
      this.$emit('isSelected', false)
    },
  },
}
</script>

<style lang="scss">
.selectYesOrNo {
  border-top: 20px solid #f9423a;
  padding: 14px;
  background: white;
  width: 250px;
  height: 70px;
  border-radius: 4px;
  display: block;
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", Osaka, sans-serif;
  text-align: center;
}
.selectYesOrNo_title {
  font-weight: bold;
}
.selectYesOrNo_btnArea {
  margin-top: 7px;
}
.selectYesOrNo_btn {
  display: inline-block;
  width: 100px;
  margin: 10px;
  outline: none;
}
</style>
